export class GetOneIpWhitelist {
    async handle(ip) {
        const apiUrl = process.env.REACT_APP_API_URL;
        //post request with a body
        const url = new URL(`/whitelist`, apiUrl);
        const response = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ip_details: {
                    ip: ip
                }
            })
        });
        const data = await response.json();
        return data;
    }
}
